import { secureModeFirmwareVersions } from '../../../../helpers/constants';

export default {
	title: 'settings',
	components: [
		{ title: 'eco_mode', component: 'eco_mode_g2' },
		{
			title: 'enhanced_security',
			component: 'enhanced_security_g2',
			min_ver: secureModeFirmwareVersions,
		},
		{ title: 'device_profile', component: 'cover_profile' },
		{ title: 'input_output', component: 'input_output_g2' },
		{ title: 'enable_input', component: 'enable_input_g2', min_ver: '1.0.7' },
		{ title: 'lock_inputs', component: 'lock_inputs_g2', min_ver: '1.6.0' },
		{ title: 'invert_switch', component: 'invert_switch_g2' },
		{ title: 'device_name', component: 'device_name_g2' },
		{ title: 'firmware_version', component: 'firmware_update' },
		{ title: 'geo_location_and_time_zone', component: 'location_g2' },
		{ title: 'device_reboot', component: 'device_reboot' },
		{ title: 'factory_reset', component: 'factory_reset' },
		{ title: 'device_information', component: 'device_information' },
	],
};
